// Pure helper for Bootstrap enforceFocus patching (see bootstrap_modal.js).
// Unit-tested without jQuery so the focus-trap rule stays honest.
//
// Bootstrap 3 keeps focus inside the open `.modal`. Tailwind ModalComponent
// roots (`.t-modal`) live outside that DOM tree — e.g. #prompt-modal opened
// from the spam manager. Without an exception, focus is stolen back and the
// nested input cannot be typed into (ENG-31953).

/**
 * @param {EventTarget | null | undefined} target
 * @returns {boolean}
 */
export function focusIsInsideOpenLayeredModal(target) {
  if (!target || typeof target.closest !== 'function') return false

  const layered = target.closest('.t-modal')
  if (!layered) return false

  // Closed shells stay in the layout DOM (prompt/confirm always rendered).
  // Only treat focus as allowed when the full-screen content outer is open.
  // Missing outer → not a real ModalComponent; keep the exception narrow.
  const outer = layered.querySelector('.t-modal-content-outer')
  if (!outer) return false

  return !outer.classList.contains('hidden')
}
